import {Component, EventEmitter, Input, Output} from '@angular/core';


@Component({
  selector: 'ui-file-input',
  standalone: true,
  imports: [],
  templateUrl: './ui-file-input.component.html',
  styleUrl: './ui-file-input.component.scss'
})
export class UiFileInputComponent {
  @Input() accept?: string;
  @Input() disabled = false;

  /** DaisyUI variant class, e.g. "file-input-primary" */
  @Input() variant: 'primary' | 'secondary' | 'accent' | 'ghost' | 'info' | 'success' | 'warning' | 'error' = 'primary';

  /** Optional label for accessibility */
  @Input() ariaLabel?: string;

  /** Emits the selected file (first file only) or null if cleared */
  @Output() fileSelected = new EventEmitter<File | null>();

  onChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0] ?? null;
    this.fileSelected.emit(file);
  }

  clear(inputEl: HTMLInputElement): void {
    inputEl.value = '';
    this.fileSelected.emit(null);
  }

  get computedClasses(): string {
    const variantClass = this.variant ? `file-input-${this.variant}` : '';
    return ['file-input', variantClass].filter(Boolean).join(' ');
  }
}

